import ConfigurationForm from '@/pages/frontend/ConfigurationForm'
import LanguageForm from '@/pages/frontend/LanguageForm'
import access from "../access";

export default {

  'frontend.settings': {
    path: '/admin/frontend',
    name: 'frontend.settings',
    component:  ConfigurationForm,
    meta: {
      access: access.admin,
      title: "Frontend settings",
      side_menu: { label: "Frontend",  icon: "paint-format", weight: 90 },
      local_actions: [
        { name: "frontend.create_language", label: "Add language", color: "success", icon: "plus" }
      ]
    },
  },

  'frontend.create_language': {
    path: '/admin/frontend/language',
    name: 'frontend.create_language',
    component: LanguageForm,
    meta: {
      title: "Translate",
      access: access.admin
    },
  },

  'frontend.update_language': {
    path: '/admin/frontend/language/:langcode',
    name: 'frontend.update_language',
    component: LanguageForm,
    props: (route) => {
      return {
        langcode: route.params.langcode,
      }
    },
    meta: {
      title: "Translate",
      access: access.admin
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/frontend.js